import {Stack, Typography} from '@mui/material';
import React from 'react';

import {ContentState} from 'presentation/components';
import {AppointmentCardSkeleton} from 'presentation/modules/myAppointments/ui/components/AppointmentCardSkeleton';
import {translations} from 'presentation/translations-new';
import {AppointmentDetailsCardContainer} from '../../styles';
import {DocumentList} from '../DocumentList';
import {useDocumentContainer} from './hooks/useDocumentContainer';
import {DocumentContainerProps} from './types';

const {examRequest, medication, sickNote, title, emptyFiles, medicalReport} =
	translations['pt-br'].privateFlow.myAppointments.myAppointmentsHistory.historyDetails
		.appointmentFiles;

export function DocumentContainer({documentId}: DocumentContainerProps) {
	const {
		isEmpty,
		isLoading,
		isError,
		colors,
		data,
		sickNotesIsEmpty,
		medicalReportsIsEmpty,
		medicationsIsEmpty,
		examRequestsIsEmpty,
		sickNotes,
		medicalReportsDocs,
		medications,
		examRequests,
	} = useDocumentContainer(documentId);

	if (isLoading) {
		return <AppointmentCardSkeleton />;
	}

	if (isError || !data) {
		return (
			<AppointmentDetailsCardContainer>
				<Typography
					color={colors.light.text.secondary}
					fontWeight={600}
					variant="subtitle2">
					{title}
				</Typography>
				<ContentState title={emptyFiles} customIconName="info-outlined" />
			</AppointmentDetailsCardContainer>
		);
	}

	if (isEmpty) {
		return (
			<AppointmentDetailsCardContainer>
				<Typography
					color={colors.light.text.secondary}
					fontWeight={600}
					variant="subtitle2">
					{title}
				</Typography>
				<ContentState title={emptyFiles} customIconName="info-outlined" />
			</AppointmentDetailsCardContainer>
		);
	}

	return (
		<Stack spacing={1}>
			<Typography color={colors.light.text.secondary} fontWeight={600} variant="subtitle2">
				{title}
			</Typography>
			{!sickNotesIsEmpty ? <DocumentList documents={sickNotes!} fileName={sickNote} /> : null}
			{!medicationsIsEmpty ? (
				<DocumentList documents={medications!} fileName={medication} />
			) : null}
			{!examRequestsIsEmpty ? (
				<DocumentList documents={examRequests!} fileName={examRequest} />
			) : null}
			{!medicalReportsIsEmpty ? (
				<DocumentList documents={medicalReportsDocs!} fileName={medicalReport} />
			) : null}
		</Stack>
	);
}
